<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form class="form-horizontal mt-3">
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('studentScoringEntry.advisor')
            }}</label>
            <select
              class="form-control"
              v-model="model.advisor_id"
              :class="{
                'is-invalid': $v.model.advisor_id.$error
              }"
            >
              <option :value="1">{{
                $t('studentscoringentry.teacher')
              }}</option>
              <option :value="2">
                {{ $t('studentscoringentry.management') }}
              </option>
              <option :value="3">{{ $t('studentscoringentry.parent') }}</option>
            </select>
            <div class="validate" v-if="errors.has('advisor_id')">
              {{ errors.first('advisor_id') }}
            </div>
            <span class="validate" v-if="advisorIdErrors.length > 0">{{
              advisorIdErrors[0]
            }}</span>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('studentScoringEntry.comment')
            }}</label>
            <ts-button
            outline
            class="ts-ml-6 ts-mb-2 ts-text-xs"
            color="info"
            @click.prevent="onClickComment"
            >{{ $t('studentScoringEntry.clickComment') }}</ts-button
            >
            <ts-button
              class="ts-ml-6 ts-mb-2 ts-text-xs"
              color="info"
              @click.prevent="onGenerateComment"
              :disabled="disabled_gnr_comment"
              >{{ $t('studentScoringEntry.generateComment') }}</ts-button
            >
            <VueEditor
              v-model="model.comments"
              :editor-toolbar="customToolbar"
              useCustomImageHandler
              :disabled="disableComment" :class="{ 'ts-bg-gray-100' : disableComment }"
            />
            <p v-if="!isOver()" class="ts-text-xs">
              You have {{ charactersRemaining }} characters remaining.
            </p>
            <p v-else class="over ts-text-xs">
              You are {{ charactersOver }} characters over the limit.
            </p>
            <div class="validate" v-if="errors.has('comments')">
              {{ errors.first('comments') }}
            </div>
            <span class="validate" v-if="commentsErrors.length > 0">{{
              commentsErrors[0]
            }}</span>
          </div>
        </div>
        <!-- <div class="row form-group">
        <div class="col-md-12">
          <label class="ts-text-xs">{{
            $t('studentScoringEntry.suggesstion')
          }}</label>
          <VueEditor
            v-model="model.suggesstion"
            :editor-toolbar="customToolbar"
            useCustomImageHandler
          />
        </div>
      </div> -->
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click="onCloseModal">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" @click.prevent="onOk">{{
              $t('ok')
            }}</ts-button>
          </div>
        </div>
        <a-modal
        v-if="clickComment"
        v-model="clickComment"
       :zIndex="1020"
       :closable="false"
        width="50%"
        :title="$t('studentScoringEntry.clickComment')"
      >
        <ClickComment v-model="model" :comments="comments"/>
        <template v-slot:footer>
        <ts-button color="primary" @click="() => (clickComment = false)">{{
          $t('ok')
        }}</ts-button>
      </template>
      </a-modal>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import ClickComment from './click-comment.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'advisorComment',
  props: ['value', 'studentProfiles'],
  components: { VueEditor,ClickComment },
  data() {
    return {
      loading: false,
      waiting: false,
      clickComment: false,
      disabled_gnr_comment: false,
      errors: new Errors(),
      comments: [],
      generate_scores: [],
      model: {},
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }]
      ],
      maxCharacters: 1500
    }
  },
  validations: {
    model: {
      advisor_id: { required },
      comments: { required }
    },
    form: ['model.advisor_id', 'model.comments']
  },
  computed: {
    advisorIdErrors() {
      const errors = []
      if (!this.$v.model.advisor_id.$error) return errors
      !this.$v.model.advisor_id.required && errors.push('Required')
      return errors
    },
    commentsErrors() {
      const errors = []
      if (!this.$v.model.comments.$error) return errors
      !this.$v.model.comments.required && errors.push('Required')
      return errors
    },
    charactersRemaining: function() {
      let textLength = this.model.comments ? this.model.comments.length : 0
      return this.maxCharacters - textLength
    },
    charactersOver: function() {
      let textLength = this.model.comments ? this.model.comments.length : 0
      return this.isOver() ? textLength - this.maxCharacters : 0
    },
    disableComment(){
      return !this.$store.getters.authPermissionAllow('update-score-comments');
    }
  },
  created() {
    this.model = this.value
    this.student = this.studentProfiles
    this.getComment()
    this.getGenerateScore()
  },
  methods: {
    isOver: function() {
      return this.charactersRemaining < 0
    },
    onClickComment() {
      this.clickComment = true
    },
    getGenerateScore(){
				this.$store
				.dispatch('studentScoringEntry/checkGenerateScore', ({
            acp_id: this.model.acp_id,
            ac_year_id: this.model.ac_year_id,
            ac_term_id: this.model.ac_term_id,
            class_id: this.model.class_id,
            st_class_id: this.model.st_class_id,
            scoring_cycle_id: this.model.scoring_cycle_id,
            cycle_value: this.model.cycle_value,
            student_id: this.model.student_id
        }))
				.then(response => {
					this.generate_scores = response.data
				})
		},
    onGenerateComment() {
      this.disabled_gnr_comment = true;

      let $grading = this.model.class_id == '22359' || this.model.class_id == '22360' || 
                 this.model.class_id == '22369' || this.model.class_id == '22370' || 
                 this.model.class_id == '22361' || this.model.class_id == '22166' ? 'ល្អ។' : ((this.generate_scores ? this.generate_scores.grading_definition.definition_name_kh : '') + '។');

      this.model.comments = 'លទ្ធផលការសិក្សារបស់អូន ' + this.student.full_name_kh + ' នៅក្នុងវគ្គ' + ' ' + 'ឆ្នាំ' + ' ' + 'គឺ' + $grading + (this.model.comments != null ? this.model.comments : '')
    },
    onOk() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('closeModal')
      }
    },
    onCloseModal() {
      this.clearInput()
      this.$emit('closeModal')
    },
    getComment(){
				this.loading = true
				this.$store
				.dispatch('studentScoringEntry/getComment')
				.then(response => {
					this.loading = false
          const commentsArray = Array.isArray(this.model.comments) ? this.model.comments : [];
					this.comments = response.data.map(el => ({
						value: el.comment_id,
						label: el.comment,
						checked: commentsArray.includes(el.comment)
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
		},
    clearInput() {
      this.model.sc_stu_com_id = 0
      this.model.advisor_id = null
      this.model.comments = null
      this.model.suggesstion = null
    }
  }
}
</script>
